import { setAuthHintCookie } from '@/utils/auth';

const STORAGE_KEYS = [
  'accessToken',
  'refreshToken',
  'username',
  'userProfile',
] as const;

const REDIRECT_KEYS = ['postLoginRedirect', 'postLoginRedirectAbs'] as const;

let epoch = 0;
let loggingOut = false;

export const getSessionEpoch = () => epoch;

export const invalidateSession = () => {
  epoch += 1;
};

export const isLoggingOut = () => loggingOut;

export const beginLogout = () => {
  loggingOut = true;
  invalidateSession();
};

export const endLogout = () => {
  loggingOut = false;
};

export const clearBrowserSession = (notifyOtherTabs = true) => {
  if (typeof window === 'undefined') return;

  try {
    STORAGE_KEYS.forEach((k) => localStorage.removeItem(k));
  } catch {}

  try {
    REDIRECT_KEYS.forEach((k) => sessionStorage.removeItem(k));
  } catch {}

  setAuthHintCookie(false);

  if (!notifyOtherTabs) return;

  try {
    localStorage.setItem(
      'auth:event',
      JSON.stringify({ type: 'logout', ts: Date.now() })
    );
    localStorage.removeItem('auth:event');
  } catch {}
};
